import { Build, h, Host } from "@stencil/core";
let recaptchaPromise;
const loadRecaptcha = () => {
    if (!recaptchaPromise) {
        recaptchaPromise = new Promise((resolve, reject) => {
            let script = document.createElement('script');
            script.async = true;
            script.type = 'text/javascript';
            script.src = '//www.google.com/recaptcha/api.js';
            script.addEventListener('load', () => grecaptcha.ready(() => resolve(grecaptcha)), false);
            script.addEventListener('error', () => reject(), false);
            document.body.appendChild(script);
        });
    }
    return recaptchaPromise;
};
export class Recaptcha {
    constructor() {
        this.forceChallenge = false;
        this.isSubmitted = false;
    }
    async componentDidLoad() {
        if (!Build.isBrowser) {
            return;
        }
        this.form.addEventListener('submit', event => this.onSubmit(event));
        this.visibilityStateChanged();
    }
    disconnectedCallback() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }
    async visibilityStateChanged() {
        this.grecaptcha = await loadRecaptcha();
        this.widgetId = this.grecaptcha.render(this.placeholder, {
            'sitekey': this.sitekey,
            'callback': (key) => {
                this.input.value = key;
                if (!this.isSubmitted) {
                    return;
                }
                if (this.submitButton) {
                    this.submitButton.click();
                }
                else {
                    this.form.submit();
                }
            },
            'expired-callback': () => this.triggerChallenge(),
            'size': 'invisible',
            'badge': 'bottomleft'
        });
        this.grecaptcha.reset(this.widgetId);
        if (this.forceChallenge) {
            this.triggerChallenge();
        }
    }
    async onSubmit(event) {
        // Take Care of back button in form
        const isSkipped = await this.uvexForm.isSkipped();
        if (isSkipped) {
            return;
        }
        const isValid = await this.uvexForm.checkValidity();
        if (!isValid || this.isSubmitted) {
            this.isSubmitted = false;
            return;
        }
        event.preventDefault();
        if (!this.grecaptcha) {
            this.isSubmitted = false;
            return;
        }
        this.isSubmitted = true;
        this.triggerChallenge();
    }
    triggerChallenge() {
        this.grecaptcha.reset(this.widgetId);
        this.grecaptcha.execute(this.widgetId);
    }
    render() {
        return (h(Host, { key: '7597fd17888803a438ca562de7627da0c0f883b5', class: "recaptcha" }, h("div", { key: '0516b509ee738f8fc18e6203c33b651c35d627fb', class: "placeholder" }), h("slot", { key: '7013a1644a1b140090b10585d42ed42c3d77dbea', name: "input" }), h("slot", { key: '347bbd8b87787e90fc1c4cba64858d69a84151f8', name: "feedback" }), h("slot", { key: 'fa374592733cb7cb091348760e2a9413e61404e8' })));
    }
    get placeholder() {
        return this.el.querySelector('.placeholder');
    }
    get input() {
        return this.el.querySelector('input');
    }
    get form() {
        return this.el.closest('form');
    }
    get uvexForm() {
        return this.el.closest('uvex-form');
    }
    get submitButton() {
        return this.form.querySelector('[data-action="next"], [data-action="submit"]');
    }
    static get is() { return "uvex-recaptcha"; }
    static get properties() {
        return {
            "sitekey": {
                "type": "string",
                "attribute": "sitekey",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false
            },
            "forceChallenge": {
                "type": "boolean",
                "attribute": "force-challenge",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=recaptcha.js.map
